
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.111 16L12.444 7.111v5.333H0v7.112h12.444v5.333L23.111 16zm5.333 12.444H14.222V32h14.222C30.4 32 32 30.4 32 28.444V3.556C32 1.6 30.4 0 28.444 0H14.222v3.556h14.222v24.888z","fill":"#B6B6B6"}})])
          )
        }
      }
    